import axios from "axios";

const API_URL = "/api/subjects";

export const getSubjects = async (params = {}) => {
  try {
    const { data } = await axios.get(API_URL, { params });
    return data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};

export const addSubject = async (payload) => {
  try {
    const { data } = await axios.post(API_URL, payload);
    return data;
  } catch (error) {
    console.error("Error adding subject:", error);
    throw error;
  }
};

export const editSubject = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API_URL}/${id}`, payload);
    return data;
  } catch (error) {
    console.error(`Error editing subject ${id}:`, error);
    throw error;
  }
};

export const deleteSubject = async (id) => {
  try {
    const { data } = await axios.delete(`${API_URL}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting subject ${id}:`, error);
    throw error;
  }
};